export default __webpack_public_path__ + "static/media/logo_alcaldia_medellin.2f991e17.svg";